import { useCallback } from 'react';

import { useRouter } from 'next/navigation';
import useAuth from '@/lib/firebase/auth/store';
import type { DecisionDialogAnswer } from '@/types/decisionFlow';
import useNotification from '../useNotification';
import useTranslations from '../useTranslations';
import companyFavouriteCarpiProductConfiguration from '@/actions/productWorkflow/carpi/productConfiguration/companyFavouriteCarpiProductConfiguration';

export default function useCompanyFavourite(
  existingCarpiProductConfigurationId: string,
  answers?: Record<string, DecisionDialogAnswer>,
) {
  const notifications = useNotification();
  const { t, locale } = useTranslations();
  const router = useRouter();
  const { userData } = useAuth();
  const companyId = userData.company.id;

  const handleCompanyFavouriting = useCallback(async () => {
    try {
      await companyFavouriteCarpiProductConfiguration(
        existingCarpiProductConfigurationId,
        locale,
        companyId,
        answers,
      );

      router.refresh();
      notifications.success(t('product.workflow.companyFavourite.success'));
    } catch (error) {
      console.error(error);
      notifications.error(t('product.workflow.companyFavourite.error'));
    }
  }, [answers, companyId, existingCarpiProductConfigurationId, locale, notifications, router, t]);

  return { handleCompanyFavouriting };
}
